import { render, staticRenderFns } from "./CustomFileUpload.vue?vue&type=template&id=5467ece1"
import script from "./CustomFileUpload.vue?vue&type=script&lang=js"
export * from "./CustomFileUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports